/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import PropTypes from "prop-types";
import { ResponsiveImage } from "@quintype/components";
import { withElementWrapper } from "../withElementWrapper";

import "./image.m.css";
import { shapeStory, shapeConfig } from "../../../../utils/utils";
import { FullScreenImages } from "../../../Molecules/FullScreenImages";
import { useStateValue } from "../../../SharedContext";
import { CaptionAttribution } from "../../CaptionAttribution";

const ImageBase = ({ element, opts = {}, story = {}, config = {}, caption = true, ...restProps }) => {
  if (!element) return null;
  const configData = useStateValue() || {};

  const ImageTemplate = ({ onClick }) => (
    <>
      <figure styleName="element" onClick={() => onClick()}>
        <ResponsiveImage
          slug={element["image-s3-key"]}
          metadata={element["image-metadata"]}
          alt={element["title"]}
          aspectRatio={null}
          defaultWidth={640}
          widths={opts.imageWidths || [360, 640, 1200]}
          sizes="(max-width: 500px) 98vw, (max-width: 768px) 48vw, 36vw"
          imgParams={{ auto: ["format", "compress"] }}
        />
      </figure>
    </>
  );

  ImageTemplate.propTypes = {
    onClick: PropTypes.func
  };

  return (
    <div className="arrow-component arr--image-element" {...restProps}>
      <FullScreenImages template={ImageTemplate} element={element} imageSlug={element["image-s3-key"]} story={story} />
      {caption && <CaptionAttribution element={element} config={configData} />}
    </div>
  );
};

ImageBase.propTypes = {
  element: PropTypes.shape({
    "image-s3-key": PropTypes.string,
    "image-metadata": PropTypes.object,
    "image-attribution": PropTypes.string,
    title: PropTypes.string
  }),
  opts: PropTypes.shape({ imageWidths: PropTypes.array }),
  story: shapeStory,
  config: shapeConfig
};

export const Image = withElementWrapper(ImageBase);
